import ExploreClinics from './ExploreClinics';

export default ExploreClinics;
